import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface GetSCNParams {
    report_id?: string;
}

export interface SCNReport {
    report_id: string;
    party_id: string;
    content?: string;
    status: ReportStatus;
    last_updated_at: string;
}

export interface SCNReportsResponse {
    scn_reports: SCNReport[];
}

export interface GenerateSCNRequest {
    party_id: string;
    report_id: string;
}

export interface UpdateSCNLegacyRequest {
    party_id: string;
    content: string;
}

export interface UpsertSCNRequest {
    party_id: string;
    content: string;
}

export enum ReportStatus {
    SUBMITTED = "SUBMITTED",
    IN_PROGRESS = "IN_PROGRESS",
    AVAILABLE = "AVAILABLE",
    FAILED = "FAILED",
}

export const SCNReportLegacyAPI = {
    get_scn: async (
        { case_id, report_id }: { case_id: string } & GetSCNParams
    ) => {
        const response: AxiosResponse<SCNReportsResponse> =
            await axiosInstance.get(
                `v1/cases/${case_id}/reports/scn`,
                report_id ? { params: { report_id } } : undefined
            );

        return response.data;
    },

    create_scn: async (
        case_id: string,
        request: GenerateSCNRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.post(
                `v1/cases/${case_id}/reports/scn`,
                request
            );

        return response.data;
    },

    upsert_scn: async (
        case_id: string,
        report_id: string,
        request: UpdateSCNLegacyRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.patch(
                `v1/cases/${case_id}/reports/scn/${report_id}`,
                request
            );

        return response.data;
    },
};

export const SCNReportAPI = {
    get_scn_reports: async (
        { case_id, report_id }: { case_id: string } & GetSCNParams
    ): Promise<SCNReportsResponse> => {
        const response: AxiosResponse<SCNReportsResponse> =
            await axiosInstance.get(
                `v1/cases/${case_id}/scn-reports`,
                report_id ? { params: { report_id } } : undefined
            );
        return response.data;
    },

    generate_scn_report: async (
        case_id: string,
        request: GenerateSCNRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.post(
                `v1/cases/${case_id}/scn-reports/generate`,
                request
            );
        return response.data;
    },

    upsert_scn_report: async (
        case_id: string,
        report_id: string,
        request: UpsertSCNRequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(
                `v1/cases/${case_id}/scn-reports/${report_id}`,
                request
            );
        return response.data;
    },
};